var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classes,on:{"drop":_vm.dropped,"dragenter":_vm.dragEnter,"dragover":_vm.dragOver,"dragleave":_vm.dragLeave}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }